import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { GALLERY } from "@/data/content";
import { SITE } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

export default function InstagramGallery() {
  const shots = GALLERY.slice(0, 6);
  return (
    <section data-testid="instagram-gallery" className="bg-ivory py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col items-center text-center">
          <Reveal><p className="mb-5 text-xs uppercase tracking-widest-2 text-brown md:text-sm">@vrukshavalley</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-display text-4xl font-bold leading-[1.05] tracking-tight text-forest sm:text-5xl md:text-6xl">
              Follow the mist on Instagram
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {shots.map((src, i) => (
            <motion.a
              key={i}
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-shot-${i}`}
              initial={{ opacity: 0, scale: 0.94 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="group relative aspect-square overflow-hidden rounded-sm"
            >
              <img src={src} alt="Vruksha Valley on Instagram" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 flex items-center justify-center bg-forest/0 transition-colors duration-300 group-hover:bg-forest/50">
                <Instagram className="h-6 w-6 text-ivory opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </div>
            </motion.a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta"
            className="group inline-flex items-center gap-2.5 rounded-full bg-forest px-8 py-4 text-sm font-medium text-ivory transition-all duration-300 hover:-translate-y-0.5 hover:bg-moss"
          >
            <Instagram className="h-5 w-5" />
            Follow @vrukshavalley
          </a>
        </div>
      </div>
    </section>
  );
}
